import React from 'react';
import '../../css/components/bronson/tag.css';

function Tag({ classes, text, clickFunction, type }) {

    const getClassName = () => {
        let classList = "";
        if (classes && classes.length > 0) {
            classes.map(item => {
                switch (item) {
                    case "success":
                        classList += " c-tag--success";
                        break;
                    case "warning":
                        classList += " c-tag--warning";
                        break;
                    case "error":
                        classList += " c-tag--error";
                        break;
                    case "info":
                        classList += " c-tag--info";
                        break;
                    case "positive":
                        classList += " c-tag--positive";
                        break;
                    case "negative":
                        classList += " c-tag--negative";
                        break;
                    //Customs
                    case "flat":
                        classList += " c-tag--flat";
                        break;
                    case "large":
                        classList += " c-tag--large";
                        break;
                    case "cpc":
                        classList += " c-tag--cpc";
                        break;
                    case "fleet":
                        classList += " c-tag--fleet";
                        break;
                    case "lineal":
                        classList += " c-tag--lineal";
                        break;
                    case "retail":
                        classList += " c-tag--retail";
                        break;
                    case "error-outline":
                        classList += " c-tag--error-outline";
                        break;
                    case "light-blue":
                        classList += " c-tag--light-blue";
                        break;
                    case "white":
                        classList += " c-tag--white";
                        break;
                    //Default
                    default:
                        classList += " " + item;
                        break;
                }
            });

        }
        return classList;
    }

    if (type == "button") {
        return (
            <button className={"c-tag " + getClassName()} onClick={clickFunction ? clickFunction : null} type="button">
                <span className="c-tag__label"> {text} </span>
            </button>
        )
    } else if (type == "corner") {
        return (
            <span className={"c-tag " + getClassName()}>
                <span className="c-tag__corner"></span>
                <span className="c-tag__label"> {text} </span>
            </span>
        )
    } else {
        return (
            <span className={"c-tag " + getClassName()}>
                <span className="c-tag__label"> {text} </span>
            </span>
        )
    }


}

export default Tag;